













import * as vueApollo from "vue-apollo";
import { Component, Prop, Vue } from "vue-property-decorator";

import Loading from "./Loading.vue";

@Component({
  components: { ApolloQuery: (vueApollo as any).ApolloQuery, Loading }
})
export default class extends Vue {
  @Prop(Object)
  private query;
  @Prop(Object)
  private variables;
}
